<template>
  <div v-if="result?.items?.length" class="promo-slider">
    <DefTitle :result="1" :center="true">
      <h2>{{ result.messages.title }}</h2>
    </DefTitle>

    <p class="promo-slider__text">
      <svg
        width="24"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.75 2C9.94891 2 10.1397 2.07902 10.2803 2.21967C10.421 2.36032 10.5 2.55109 10.5 2.75V5.25C10.5 5.44891 10.421 5.63968 10.2803 5.78033C10.1397 5.92098 9.94891 6 9.75 6C9.55109 6 9.36032 5.92098 9.21967 5.78033C9.07902 5.63968 9 5.44891 9 5.25V2.75C9 2.55109 9.07902 2.36032 9.21967 2.21967C9.36032 2.07902 9.55109 2 9.75 2ZM4.97 3.97C5.11063 3.82955 5.30125 3.75066 5.5 3.75066C5.69875 3.75066 5.88937 3.82955 6.03 3.97L7.78 5.72C7.85369 5.78866 7.91279 5.87146 7.95378 5.96346C7.99477 6.05546 8.01681 6.15477 8.01859 6.25548C8.02037 6.35618 8.00184 6.45621 7.96412 6.5496C7.9264 6.64299 7.87026 6.72782 7.79904 6.79904C7.72782 6.87026 7.64299 6.9264 7.5496 6.96412C7.45621 7.00184 7.35618 7.02037 7.25548 7.01859C7.15477 7.01681 7.05546 6.99477 6.96346 6.95378C6.87146 6.91279 6.78866 6.85369 6.72 6.78L4.97 5.03C4.82955 4.88937 4.75066 4.69875 4.75066 4.5C4.75066 4.30125 4.82955 4.11063 4.97 3.97ZM14.53 3.97C14.6705 4.11063 14.7493 4.30125 14.7493 4.5C14.7493 4.69875 14.6705 4.88937 14.53 5.03L12.78 6.78C12.7113 6.85369 12.6285 6.91279 12.5365 6.95378C12.4445 6.99477 12.3452 7.01681 12.2445 7.01859C12.1438 7.02037 12.0438 7.00184 11.9504 6.96412C11.857 6.9264 11.7722 6.87026 11.701 6.79904C11.6297 6.72782 11.5736 6.64299 11.5359 6.5496C11.4982 6.45621 11.4796 6.35618 11.4814 6.25548C11.4832 6.15477 11.5052 6.05546 11.5462 5.96346C11.5872 5.87146 11.6463 5.78866 11.72 5.72L13.47 3.97C13.6106 3.82955 13.8012 3.75066 14 3.75066C14.1988 3.75066 14.3894 3.82955 14.53 3.97ZM3 8.75C3 8.55109 3.07902 8.36032 3.21967 8.21967C3.36032 8.07902 3.55109 8 3.75 8H6.25C6.44891 8 6.63968 8.07902 6.78033 8.21967C6.92098 8.36032 7 8.55109 7 8.75C7 8.94891 6.92098 9.13968 6.78033 9.28033C6.63968 9.42098 6.44891 9.5 6.25 9.5H3.75C3.55109 9.5 3.36032 9.42098 3.21967 9.28033C3.07902 9.13968 3 8.94891 3 8.75ZM11.177 8.486C10.322 7.752 9 8.36 9 9.487V20.761C9 21.971 10.495 22.543 11.302 21.641L13.916 18.718C14.192 18.41 14.58 18.228 14.993 18.211L18.833 18.057C20.03 18.009 20.548 16.518 19.638 15.737L11.178 8.486H11.177ZM10.5 20.287V9.881L18.312 16.577L14.932 16.712C14.5272 16.7284 14.1299 16.8258 13.7635 16.9987C13.3971 17.1715 13.0691 17.4161 12.799 17.718L10.5 20.287Z"
          fill="#363636"
        />
      </svg>

      {{ result?.messages?.look }}
    </p>

    <DefSwiper :settings="settings">
      <SwiperSlide v-for="(item, key) in result?.items" @click="handlerOpenGallery(key)">
        <DefImg :result="item.previewPicture" />
      </SwiperSlide>
    </DefSwiper>
  </div>
</template>

<script lang="ts" setup>
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import { SwiperSlide } from 'swiper/vue';
import { SwiperOptions } from 'swiper/types/swiper-options';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import { ref } from 'vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import useModal from '@use/useModal/useModal';
import PromoGallery from '@components/Promo/PromoSlider/PromoGallery/PromoGallery.vue';
import { IPromoSliderResult } from '@components/Promo/PromoSlider/IPromoSlider';

const modal = useModal();

const prev = ref<HTMLDivElement>();
const next = ref<HTMLDivElement>();

const props = defineProps<{
  result: IPromoSliderResult;
}>();

const settings: SwiperOptions = {
  slidesPerView: 4,
  spaceBetween: 4,
  slidesPerGroup: 4,
  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 8,
      slidesPerGroup: 5,
    },
    992: {
      slidesPerView: 6,
      spaceBetween: 16,
      slidesPerGroup: 6,
    },
  },
};
const handlerOpenGallery = (slideNumber: number) => {
  // let width = '336px';
  //
  // if (screenWidth.value >= 768) {
  //   width = '444px';
  // }

  modal.showGallery(PromoGallery, { result: props.result, slideNumber }, {});
};
</script>

<style lang="scss" scoped>
.promo-slider {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  &__text {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #363636;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 24px;
    }
    @include point-lg {
      margin-bottom: 32px;
      font-size: 20px;
      line-height: 20px;
    }
    svg {
      transform: translateY(4px);
    }
  }
  :deep(.def-title) {
    margin-bottom: 12px;
    @include point-lg {
      margin-bottom: 20px;
    }
  }
  :deep(.swiper-slide) {
    cursor: pointer;
  }
}
</style>
